package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionPlanRepository
import dev.zacsweers.metro.Inject

class RefreshSubscriptionPlansUseCase @Inject constructor(
    private val repository: SubscriptionPlanRepository
) {
    suspend operator fun invoke(): Result<Unit> = repository.refreshSubscriptionPlans()
}
